import ClassNames from "classnames";

import styles from "./index.module.scss";

export default function SessionReminderCard({ plain, ...props }) {
  return (
    <div
      className={ClassNames(
        styles.sessionReminderBlock,
        plain ? styles.plain : ""
      )}
    >
      <div className={styles.header}>
        {props.header}{" "}
        <span className={styles.headerDateTime}>
          {props.date}
          {props.time ? <>, {props.time}</> : ""}
        </span>
        .
      </div>
      <div className={styles.notes}>{props.notes}</div>
    </div>
  );
}
